import { EnabledFeaturesResponse } from "js/api/coursesConfig";

export function isCoursesEnabledForTeacher(enabledFeaturesResponse: EnabledFeaturesResponse): boolean {
	return enabledFeaturesResponse.features.some((feature) => feature.name === "COURSES" && feature.enabled);
}
